import produce from "immer"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initTaskCommentState: types.TaskCommentState = {
    commentList: {},
}

const taskCommentReducer = produce((
    draft: types.TaskCommentState = initTaskCommentState,
    action: ActionTypes = null,
): types.TaskCommentState => {
    switch (action.type) {
        case types.TASK_COMMENT_LIST:
            draft.commentList = {
                ...draft.commentList,
                [action.taskId]: action.comments,
            }
            return draft

        default:
            return draft
    }
})
export default taskCommentReducer
